exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".privacySettingsFooter---32UD5 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  height: 77px;\n  padding-right: 10px;\n  background-color: #adb6bc; }\n  .privacySettingsFooter---32UD5 .cancelButton---1wcEv, .privacySettingsFooter---32UD5 .saveButton---2WcZ3 {\n    width: 115px;\n    height: 45px;\n    border-radius: 22px;\n    margin: 10px;\n    padding-top: 14px;\n    color: #fff;\n    background-color: #415667;\n    font-family: Poppins;\n    font-size: 16px;\n    line-height: 20px; }\n  .privacySettingsFooter---32UD5 .saveButton---2WcZ3 {\n    width: 95px; }\n", ""]);

// exports
exports.locals = {
	"privacySettingsFooter": "privacySettingsFooter---32UD5",
	"cancelButton": "cancelButton---1wcEv",
	"saveButton": "saveButton---2WcZ3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/privacy-settings/sub-components/privacy-settings-footer/index.scss
// module id = 717
// module chunks = 3